import { gql } from '@apollo/client';

export const CORE_MEMBER_FIELDS = gql`
  fragment CoreMemberFields on Member {
    id
    createdAt
    role
    user {
      id
      email
      name
      lastLoginAt
    }
  }
`;

export const CORE_GROUP_FIELDS = gql`
  ${CORE_MEMBER_FIELDS}
  fragment CoreGroupFields on Group {
    id
    name
    description
    members {
      ...CoreMemberFields
    }
    membersCount
    pendingInvitations {
      id
      name
      email
    }
    groupOwner {
      id
      name
    }
    createdAt
    updatedAt
  }

  ${CORE_MEMBER_FIELDS}
`;

export const CORE_INVITATION_FIELDS = gql`
  fragment CoreInvitationFields on Invitation {
    id
    email
    invitedDate
    lastReminderAt
    name
    numberOfReminders
    role
    source
    status
  }
`;

export const CORE_INVITATION_RESPONSE_FIELDS = gql`
  ${CORE_INVITATION_FIELDS}
  ${CORE_MEMBER_FIELDS}
  fragment CoreInvitationResponseFields on BatchInvitationResponse {
    successInvitations {
      ...CoreInvitationFields
    }
    successMembers {
      ...CoreMemberFields
    }
    failed {
      id
      email
      error
      message
      name
      reason
      role
    }
    emailSentInvitations {
      email
      name
      role
    }
  }
`;

export const CORE_PLAYLIST_FIELDS = gql`
  fragment CoreOrganizationPlaylistFields on Playlist {
    id
    shortId
    publishedAt
    status
    shareType
    name {
      languageCode
      value
    }
    description {
      languageCode
      value
    }
    courses {
      id
    }
    ownerId
  }
`;
